import { createSlice, createSelector } from "@reduxjs/toolkit";
import CollectionItemProfile from "../../../models/CollectionItemProfile";

// TODO: Could the "loader" part of these slices be inherited somehow? (eg. a base class)

// TODO: How do I differentiate between data: null because it's not loaded yet, and data: null because it's not found?

const initialState = {
    status: "idle",
    latestRequestTimestamp: null,
    data: null,
};

const collectionItemProfileSlice = createSlice({
    name: "collectionItemProfile",
    initialState,
    reducers: {
        resetCollectionItemProfile: (state, action) => initialState,

        requestStarted: (state, action) => {
            state.status = "loading";
            state.latestRequestTimestamp = action.payload;
        },
        requestSucceeded: (state, action) => {
            if (action.payload.timestamp === state.latestRequestTimestamp) {
                state.status = "idle";
                state.latestRequestTimestamp = null;
                state.data = { ...action.payload.data };
            }
        },
    },
});

/**
 * Add actions
 */

export const setCollectionItemProfile = (id) => async (dispatch, getState) => {
    const timestamp = Date.now();

    dispatch(collectionItemProfileSlice.actions.requestStarted(timestamp));

    const data = await CollectionItemProfile.find(id);

    dispatch(
        collectionItemProfileSlice.actions.requestSucceeded({
            data,
            timestamp,
        })
    );
};

export const {
    resetCollectionItemProfile,
} = collectionItemProfileSlice.actions;

/**
 * Add selectors (memoised to prevent re-renders when unrelated state changes)
 */

const selectCollectionItemProfileData = (state) => state.collectionItemProfile.data;
export const getCollectionItemProfile = createSelector(
    [selectCollectionItemProfileData],
    (data) => (data ? CollectionItemProfile.fromObject(data) : null)
);

/**
 * Export reducer
 */

export default collectionItemProfileSlice.reducer;
